import { createContext, useState } from 'react';
import {
    createUpdateFormData,
    createUpdateMultipleFields,
    createResetForm,
    getInitialFormData,
} from '../utils/customSIPHeaderFormUtils.js';

export const CustomSIPHeaderFormContext = createContext();

export const CustomSIPHeaderFormProvider = ({ children, initialData = {} }) => {
    const [formData, setFormData] = useState(getInitialFormData(initialData));
    const [initialFormData, setInitialFormData] = useState(
        getInitialFormData(initialData),
    );
    const [mode, setMode] = useState();

    const updateFormData = createUpdateFormData(setFormData);
    const updateMultipleFields = createUpdateMultipleFields(setFormData);
    const resetForm = createResetForm(setFormData, initialData);

    const value = {
        formData,
        setFormData,
        updateFormData,
        updateMultipleFields,
        resetForm,
        mode,
        setMode,
        initialFormData,
        setInitialFormData,
    };

    return (
        <CustomSIPHeaderFormContext.Provider value={value}>
            {children}
        </CustomSIPHeaderFormContext.Provider>
    );
};
